"use client";
import styles from "./InputDesign.module.css";

export const CreditsDisplay = () => {
  return (
    <section className={styles.creditsCard}>
      <h3 className={styles.creditsTitle}>Credits</h3>
      <div className={styles.creditsContent}>
        <div className={styles.progressContainer}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill}>
              <div className={styles.progressSpacer} />
              <div className={styles.progressThumb}>
                <div className={styles.thumbCircle} />
              </div>
            </div>
          </div>
          <div className={styles.progressData}>
            <div className={styles.progressDataLeft}>
              <div className={styles.progressDataLeftLine}>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/24c8e2c666acb619b138e2d4d9d0cdf6a7a5071b?placeholderIfAbsent=true"
                  alt=""
                  className={styles.progressLine}
                />
              </div>
              <div className={styles.spentLabel}>Spent 250</div>
            </div>
            <div className={styles.creditsRemaining}>
              <img
                src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/e0c2b2dfc3321478c2884bd60852addcf5546712?placeholderIfAbsent=true"
                alt="Credits icon"
                className={styles.creditsIcon}
              />
              <div className={styles.creditsText}>250 Left</div>
            </div>
            <div className={styles.progressDataRight}>
              <div className={styles.progressDataRightLine}>
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/e4c4028bee2e4c02982439ab63d2ae0b/24c8e2c666acb619b138e2d4d9d0cdf6a7a5071b?placeholderIfAbsent=true"
                  alt=""
                  className={styles.progressLine}
                />
              </div>
              <div className={styles.limitLabel}>Limit 500</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
